import { types, getParent, flow } from "mobx-state-tree"

import TrafficTicket from "~/stores/models/TrafficTicket"

import * as TrafficTicketService from "~/services/trafficTicket"
import Network from "./Network"

const UserTickets = types
  .model("UserTickets", {
    list: types.array(TrafficTicket),
    ticketsService: types.optional(Network, {})
  })
  .views(self => ({
    get sessionToken() {
      return getParent(self).auth.user.sessionToken
    },
    get isLoading() {
      const singleItemIsLoading = self.list.reduce((isLoading, ticket) => {
        if (isLoading || ticket.isLoading) return true
        return false
      }, false)
      return self.ticketsService.isLoading || singleItemIsLoading
    }
  }))
  .actions(self => ({
    setTickets(tickets) {
      const ids = tickets.map(t => t.objectId)
      const newIds = new Set(ids)
      self.list = [
        ...self.list.filter(i => !newIds.has(i.objectId)),
        ...tickets
      ]
      self.list.forEach(ticket => {
        if (newIds.has(ticket.objectId)) ticket.setLastUpdate()
      })
    },
    loadIfNecessary() {
      return self.fetchAll()
    },
    fetchByObjectId: flow(function* fetchByObjectIdGen(objectId) {
      let success = false
      try {
        if (!self.sessionToken) return false // user is not signed in
        if (self.ticketsService.isLoading) {
          return true
        }
        self.ticketsService.requestStart()
        const ticket = yield TrafficTicketService.get(
          objectId,
          self.sessionToken
        )
        self.setTickets([ticket])
        success = true
        self.ticketsService.requestComplete()
      } catch (error) {
        if (process.env.WINIT_ENV !== "test") {
          console.error("error fetching all of a users traffic tickets", error)
        }
        success = false
        self.ticketsService.requestError(error)
      }
      return success
    }),
    fetchAll: flow(function* fetch() {
      let success = false
      try {
        if (!self.sessionToken) return false // user is not signed in
        if (self.ticketsService.isLoading) {
          return true
        }
        self.ticketsService.requestStart()
        const tickets = yield TrafficTicketService.getAll(self.sessionToken)
        self.setTickets(tickets)
        success = true
        self.ticketsService.requestComplete()
      } catch (error) {
        if (process.env.WINIT_ENV !== "test") {
          console.error("error fetching all of a users traffic tickets", error)
        }
        success = false
        self.ticketsService.requestError(error)
      }
      return success
    })
  }))

export default UserTickets
